module.exports = __webpack_public_path__ + "img/icons_33.b512194d.png";